<p-table [columns]="tableCols" [value]="masterLists" selectionMode="single" [(selection)]="selectedMasterList"
  (onRowSelect)="onRowSelect($event)" [loading]="loading">
  <ng-template pTemplate="caption">
    Library Configuration
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th id="{{col.field+'Column'}}" *ngFor="let col of columns"
        [pSortableColumn]="col.field=='lab' ? col.sort:col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field=='lab' ? col.sort:col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let col of columns">
        <td class="wrapword" [ngStyle]="{'display': col.display}"
          *ngIf="col.field != 'active' && col.field != 'lab'  && col.field != 'entryQcFAAssayType'   && col.field != 'defaultValue' && col.field != 'process'">
          {{rowData[col.field]}}
        </td>
        <td *ngIf="col.field == 'active' || col.field == 'defaultValue'">
          <p-checkbox id="active" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>
        <td *ngIf="col.field == 'lab' ">
          {{rowData[col.field]!= null? rowData[col.field].name :''}}
        </td>
        <td *ngIf="col.field == 'entryQcFAAssayType' " style="word-break:break-all;">
          {{rowData[col.field]!= null? rowData[col.field] :""}}
        </td>
        <td *ngIf=" col.field == 'process' " style="word-break:break-all;">
          <pre>{{rowData[col.field]!= null? rowData[col.field].join("\n") :""}}</pre>
        </td>

      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div class="text-left">
      <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddMasterList()" class="h-2rem" label="Add"></button>
    </div>
  </ng-template>
</p-table>



<p-dialog header="Library Configuration Details" [(visible)]="displayMasterListDialog" [focusOnShow]="false"
  showEffect="fade" [modal]="true" [style]="{'width':'90vw'}" [contentStyle]="{'overflow':'auto'}" [baseZIndex]="1000">
  <div *ngIf="masterList">
    <div class="tbl-col">
      <label>Name</label>
      <input type="text" pInputText class="form-control" [style]="{'width':'380px'}" [(ngModel)]="masterList.name"
        name="" id="">

      <label>Lab</label>
      <p-dropdown [options]="labOptions" placeholder="Select a Lab" [(ngModel)]="selectedLab" optionLabel="name"
        [showClear]="true"></p-dropdown>

      <label>Process</label>
      <p-multiSelect [options]="processOptions" [style]="{'min-width':'230px'}" defaultLabel="Select  Process(es)"
        [(ngModel)]="selectedProcess" [panelStyle]="{minWidth:'25em'}" optionLabel="name"></p-multiSelect>

      <label>Buffer</label>
      <p-dropdown [options]="bufferChemicalOptions" placeholder="select a buffer" [(ngModel)]="selectedBuffer"
        filter="true" optionLabel="label" 
                    optionValue="value" filterBy="label" [style]="{'width':'230px'}" [showClear]="true"></p-dropdown>

      <label>Entry QC-FA assay Type</label>
      <p-dropdown [options]="assayTypeOptions" [(ngModel)]="selectedAssayType" optionLabel="label"
        [style]="{'width':'230px'}" placeholder="Select an AssayType" [showClear]="true"></p-dropdown>

      <label>Entry QC-min conc (ng/µl)</label>
      <p-inputNumber [showButtons]="true" step="0.1" size="30" [min]="0" [(ngModel)]="masterList.entryQCMinConc">
      </p-inputNumber>

      <label>Entry QC-max conc (ng/µl)</label>
      <p-inputNumber [showButtons]="true" step="0.1" size="30" [min]="0" [(ngModel)]="masterList.entryQCMaxConc">
      </p-inputNumber>

      <label>Entry QC-Target volume (µl)</label>
      <p-inputNumber [showButtons]="true" step="0.1" size="30" [min]="0" [(ngModel)]="masterList.entryQCTargetVolume">
      </p-inputNumber>

      <label>Entry QC-max volume to start the Lib Prep (µl)</label>
      <p-inputNumber [showButtons]="true" step="0.1" size="30" [min]="0"
        [(ngModel)]="masterList.entryQCMaxVolumeToStartTheLibPrep"></p-inputNumber>

      <label>Default Amount to start the Lib Prep (ng)</label>
      <p-inputNumber [showButtons]="true" step="0.1" size="30" [min]="0"
        [(ngModel)]="masterList.defaultAmountToStartTheLibPrep"></p-inputNumber>

      <label>Entry QC-min DNA/RNA amount (ng)</label>
      <p-inputNumber [showButtons]="true" step="0.1" size="30" [min]="0"
        [(ngModel)]="masterList.entryQCMinDNARNAAmount"></p-inputNumber>

      <label>Entry QC-min DQN/RQN</label>
      <p-inputNumber [showButtons]="true" step="0.1" size="30" [min]="0" [(ngModel)]="masterList.entryQCMinDQNRQN ">
      </p-inputNumber>
    </div>

    <div class="tbl-col">
      <label> <strong>final</strong> LibQC - min molarity (nM)</label>
      <p-inputNumber [showButtons]="true" step="0.1" size="30" [min]="0" [(ngModel)]="masterList.libQCMinMolarity ">
      </p-inputNumber>

      <label> <strong>final</strong> LibQC - min size (bp)</label>
      <p-inputNumber [showButtons]="true" step="0.1" size="30" [min]="0" [(ngModel)]="masterList.libQCMinSize ">
      </p-inputNumber>

      <label> <strong>final</strong> LibQC - max size (bp)</label>
      <p-inputNumber [showButtons]="true" step="0.1" size="30" [min]="0" [(ngModel)]="masterList.libQCMaxSize ">
      </p-inputNumber>

      <label> <strong>final</strong> LibQC - fixed fragment size (bp)</label>
      <p-inputNumber [showButtons]="true" step="0.1" size="30" [min]="0" [(ngModel)]="masterList.libQCFixedFragmentSize ">
      </p-inputNumber>

      <label> <strong>final</strong> LibQc - min number of conc measurements</label>
      <p-inputNumber [showButtons]="true" size="30" [min]="0" [max]="4"
        [(ngModel)]="masterList.libQcMminNumberOfConcMeasurements"></p-inputNumber>

      <label> <strong>final</strong> LibQc - max allowed conc measurement difference (%)</label>
      <p-inputNumber [showButtons]="true" size="30" [min]="1" [max]="99"
        [(ngModel)]="masterList.libQcMmaxAllowedConcMeasurementDiffrence"></p-inputNumber>
      <br><br><br><br>
      <label> <strong>preHyb</strong> LibQC - min conc (ng/µl)</label>
      <p-inputNumber [showButtons]="true" step="0.1" size="30" [min]="0" [(ngModel)]="masterList.preHybLibQCMinConc">
      </p-inputNumber>

      <label> <strong>preHyb</strong> LibQc - min number of conc measurements</label>
      <p-inputNumber [showButtons]="true" size="30" [min]="0" [max]="4"
        [(ngModel)]="masterList.preHybLibQCMinNumberOfConcMeasurements"></p-inputNumber>

      <label> <strong>preHyb</strong> LibQc - max allowed conc measurement difference (%)</label>
      <p-inputNumber [showButtons]="true" size="30" [min]="1" [max]="99"
        [(ngModel)]="masterList.preHybLibQCMaxAllowedConcMeasurementDifference"></p-inputNumber>
    </div>
    <div class="tbl-col">
      <label> <strong> LibQC 1</strong>- min conc (ng/µl)</label>
      <p-inputNumber [showButtons]="true" step="0.1" size="30" [min]="0" [(ngModel)]="masterList.libQC1MinConc">
      </p-inputNumber>

      <label> <strong> LibQc 1</strong>- min number of conc measurements</label>
      <p-inputNumber [showButtons]="true" size="30" [min]="0" [max]="4"
        [(ngModel)]="masterList.libQC1MinNumberOfConcMeasurements"></p-inputNumber>

      <label> <strong> LibQc 1</strong>- max allowed conc measurement difference (%)</label>
      <p-inputNumber [showButtons]="true" size="30" [min]="1" [max]="99"
        [(ngModel)]="masterList.libQC1MaxAllowedConcMeasurementDifference"></p-inputNumber>

      <br><br><br><br>

      <label> <strong> LibQC 2</strong>- min conc (ng/µl)</label>
      <p-inputNumber [showButtons]="true" step="0.1" size="30" [min]="0" [(ngModel)]="masterList.libQC2MinConc">
      </p-inputNumber>

      <label> <strong> LibQc 2</strong>- min number of conc measurements</label>
      <p-inputNumber [showButtons]="true" size="30" [min]="0" [max]="4"
        [(ngModel)]="masterList.libQC2MinNumberOfConcMeasurements"></p-inputNumber>

      <label> <strong> LibQc 2</strong>- max allowed conc measurement difference (%)</label>
      <p-inputNumber [showButtons]="true" size="30" [min]="1" [max]="99"
        [(ngModel)]="masterList.libQC2MaxAllowedConcMeasurementDifference"></p-inputNumber>

      <label>Default </label>
      <p-checkbox name="Default" [(ngModel)]="masterList.defaultValue" binary="true"></p-checkbox>

      <label>Active </label>
      <p-checkbox name="Active" [(ngModel)]="masterList.active" binary="true"></p-checkbox>
      <p></p>

      <div class="savebtn">
        <p-button icon="pi pi-check" class="h-2rem flex justify-content-end" label="Save" [disabled]="isSaveDisabled()" (onClick)="saveMasterListData()">
        </p-button>
      </div>
    </div>
  </div>
</p-dialog>

<p-blockUI [blocked]="blocked">
  <div>
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
